export default {
  getAppList: {
    method: 'get',
    url: 'open-account/list',
    permission: {
      name: "获取应用账号列表",
      page: "appList",
    }
  },
  addApp: {
    method: 'post',
    url: 'open-account/add',
    permission: {
      name: "添加应用账号",
      page: "appList",
    }
  },
  reviseApp: {
    method: 'post',
    url: 'open-account/mod',
    permission: {
      name: "修改应用账号",
      page: "appList",
    }
  },
  deleteApp: {
    method: 'post',
    url: 'open-account/del',
    permission: {
      name: "删除应用账号",
      page: "appList",
    }
  }
}
